/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsProjectRequest extends models.AppSecopsProjectBase {
    getFixupPrototypeFunction() { return AppSecopsProjectRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsProjectRequest>): AppSecopsProjectRequest {
        let obj = Object.assign(new AppSecopsProjectRequest(), model);
        AppSecopsProjectRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsProjectRequest>): AppSecopsProjectRequest {
        if (!model) return null;
        return AppSecopsProjectRequest.newInstance(<AppSecopsProjectRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsProjectRequest) {
        if (!obj) return;

        models.AppSecopsProjectRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsProjectRequest): boolean {
        if (models.AppSecopsProjectBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsProjectRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
